import jsCookie from '@s-ui/js/lib/cookie'

import {UserDiscardedAdsListValueObject} from '../ValueObjects/UserDiscardedAdsListValueObject.js'
import {UserDiscardedAdsRepository} from './UserDiscardedAdsRepository.js'

export class CookieUserDiscardedAdsRepository extends UserDiscardedAdsRepository {
  #config
  #discardedAdsValueObject
  #cookieExpiration
  #cookieNamePrefix

  static create({config}) {
    return new CookieUserDiscardedAdsRepository({
      config,
      discardedAdsValueObject: UserDiscardedAdsListValueObject.create
    })
  }

  constructor({config, discardedAdsValueObject}) {
    super()
    this.#config = config
    this.#cookieExpiration = this.#config.get('cookieLayer').COOKIE_DISCARDED_ADS_EXPIRATION
    this.#cookieNamePrefix = this.#config.get('cookieLayer').COOKIE_PREFIX_DISCARDED_ADS
    this.#discardedAdsValueObject = discardedAdsValueObject
  }

  #getCookieName({userId}) {
    return `${this.#cookieNamePrefix}${userId}`
  }

  #getDiscardedAdsCookieData({userId}) {
    const cookie = this.#config.get('cookie')
    const cookieName = this.#getCookieName({userId})

    return cookie && cookie[cookieName] && JSON.parse(cookie[cookieName])
  }

  /**
   * @param {Object} params
   * @param {String} params.adId
   * @param {String} params.userId
   * @return {Promise}
   */
  async addDiscardedAd({adId, userId}) {
    const cookieName = this.#getCookieName({userId})

    const discardedAdsCookie = await jsCookie.get(cookieName)

    let discardedAdsToStore = []

    if (discardedAdsCookie) {
      const discardedAdsFromCookie = JSON.parse(discardedAdsCookie)

      discardedAdsToStore = [...discardedAdsFromCookie]

      // To avoid large size cookie, we only store the last 50 discarded ads
      const MAX_DISCARDED_ADS = 50
      const needToCleanDiscardedAds = discardedAdsFromCookie.length > MAX_DISCARDED_ADS
      if (needToCleanDiscardedAds) discardedAdsToStore.shift()

      if (!discardedAdsFromCookie.includes(adId)) {
        discardedAdsToStore.push(adId)
      }
    } else {
      discardedAdsToStore.push(adId)
    }

    return jsCookie.set(cookieName, JSON.stringify(discardedAdsToStore), {expires: this.#cookieExpiration})
  }

  async getDiscardedAds({userId}) {
    const discardedAdsCookie = this.#getDiscardedAdsCookieData({userId})
    const discardedAds = discardedAdsCookie || []

    return this.#discardedAdsValueObject({items: discardedAds})
  }
}
